export default function LicensingContentController() {}
